import { TrackingRequest } from "../@types/ShipmentTracking";
import shipvistaAPI from "./shipvistaAPI";

export const getTrackingDetails = (data: TrackingRequest) => {
  return shipvistaAPI.post(`Shipments/GetTrackingDetails`, data);
};
